import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { getClassName, THEMES } from '../../utils'

import './toolbar.component.scss'

/**
 * Toolbar Component
 */
class Toolbar extends PureComponent {
  /**
   * Render Toolbar component
   * @return {XML}
   */
  render () {
    const { theme, children, className } = this.props

    const baseClassName = getClassName('toolbar', [
      { condition: className, trueClassName: className },
      { condition: theme, trueClassName: `toolbar--${theme}` }
    ])

    return (
      <div className={baseClassName}>
        <div className='toolbar_inner'>
          {children}
        </div>
      </div>
    )
  }
}

Toolbar.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf([THEMES.RAIN, THEMES.STEEL]),
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
}

Toolbar.defaultProps = {
  theme: THEMES.RAIN
}

export default Toolbar
